function e(e,r){return Object.defineProperty(e,"__recipe__",{value:r,writable:!1}),e}export{e as addFunctionSerializer};
